
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    LayerInfoToolsSwitcherButtonComponent
} from "@/components/layer/info/tools/buttons/layer-info-tools-switcher-button-component";
import {LayerInfoToolsDrawButtonComponent} from "@/components/layer/info/tools/buttons/layer-info-tools-draw-button-component";
import {
    LayerInfoToolsMeasureButtonComponent
} from "@/components/layer/info/tools/buttons/layer-info-tools-measure-button-component";
import {
    LayerInfoToolsMutationButtonComponent
} from "@/components/layer/info/tools/buttons/layer-info-tools-mutation-button-component";
import {LayerInfoToolsDrawComponent} from "@/components/layer/info/tools/layer-info-tools-draw-component";
import {LayerInfoToolsTemplateComponent} from "@/components/layer/info/tools/layer-info-tools-template-component";
import {LayerInfoToolsMeasureComponent} from "@/components/layer/info/tools/layer-info-tools-measure-component";
import {LayerInfoToolsMutationComponent} from "@/components/layer/info/tools/layer-info-tools-mutation-component";
import {LayerInfoTools3dComponent} from "@/components/layer/info/tools/layer-info-tools-3d-component";
import {
    LayerInfoToolsMeasureTemplateComponent
} from "@/components/layer/info/tools/layer-info-tools-measure-template-component";
import {LayerInfoToolsButtonsComponent} from "@/components/layer/info/tools/buttons/layer-info-tools-buttons-component";

export class LayerInfoToolsComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
<div class="card m-3 bg-lighter" style="border-radius: 10px;min-height:460px">
     <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
         <h2><span class="fa fa-pencil-ruler title-icon"></span> Tekenen en meten
         <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnCloseInfoMenu" data-parent-element="layer-info-tools">
            <span class="fa fa-times"></span>
         </button>
         <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu d-none">
            <span class="fa fa-minus"></span>
         </button>
         </h2>
     </div>
<!--     <layer-info-tools-buttons></layer-info-tools-buttons>-->
     <div class="card m-2">
           <layer-info-tools-measure class="layer-info-tool-button"></layer-info-tools-measure>
<!--           <layer-info-tools-draw class="d-none layer-info-tool-button"></layer-info-tools-draw>-->
     </div>
      <layer-info-tools-3d class="d-none layer-info-tool-button"></layer-info-tools-3d>
</div>
`;

        initWebComponent(this, template)
    }
}

window.customElements.define("layer-info-tools-switcher-button", LayerInfoToolsSwitcherButtonComponent);

window.customElements.define("layer-info-tools-draw-button", LayerInfoToolsDrawButtonComponent);
window.customElements.define("layer-info-tools-draw", LayerInfoToolsDrawComponent);

window.customElements.define("layer-info-tools-measure-button", LayerInfoToolsMeasureButtonComponent);
window.customElements.define("layer-info-tools-measure", LayerInfoToolsMeasureComponent);

window.customElements.define("layer-info-tools-mutation-button", LayerInfoToolsMutationButtonComponent);
window.customElements.define("layer-info-tools-mutation", LayerInfoToolsMutationComponent);

window.customElements.define("layer-info-tools-3d", LayerInfoTools3dComponent);

window.customElements.define("layer-info-tools-template", LayerInfoToolsTemplateComponent);
window.customElements.define("layer-info-tools-measure-template", LayerInfoToolsMeasureTemplateComponent);

window.customElements.define("layer-info-tools-buttons", LayerInfoToolsButtonsComponent);
